export enum PlatformType {
  SAAS = "SAAS",
  PREM = "PREM",
  EDGE = "EDGE",
}
